<template>
  <div class="status__listing" v-if="latest.listing">
    <a target="_blank" :href="`https://poshmark.com/listing/${latest.listing.id}`">
      <img :src="latest.listing.image" width="440" height="440" />
      <h2>${{latest.listing.price}} - {{latest.listing.title}}</h2>
    </a>
    <p v-if="date">{{date}}</p>
  </div>
</template>
<script>
export default {
  props: ['latest'],
  computed: {
    date() {
      if (this.latest.finishedOn) {
        return `Shared at ${new Date(this.latest.finishedOn).toLocaleString()}`;
      }
      if (this.latest.listing.date) {
        return new Date(this.latest.listing.date).toLocaleDateString();
      }
      return null;
    },
  },
};
</script>
